import urlConfig from "../../config.json";
import { BACKEND_URL } from "../../constants";
import { axios } from "../../utils/axiosConfig";

export const passwordResetCheckEmail = async (email) => {
  const ROUTE = urlConfig.backend.routes.authentication.passwordResetCheckEmail;
  const url = `${BACKEND_URL}${ROUTE}`;
  const reqData = { email };

  return await axios
    .post(url, reqData)
    .then((res) => {
      if (res.status === 200) {
        return { error_code: 1, res: res.data };
      }
      return {
        error_code: 2,
        error_message: "Unable to validate email.",
      };
    })
    .catch((error) => {
      return {
        error_code: 2,
        error_message:
          error?.response?.data?.message ||
          error?.response?.data?.detail ||
          "Email not found or request failed.",
      };
    });
};
